var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "main-container",
      class: _vm.colorMode === "dark" ? "dark-block" : "",
    },
    [
      _c("h2", [_vm._v("Looking for your next African investment?")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    Cut through the noise by using our Virtual Deal Rooms as a digital on-ramp\n    to opportunities that have been pre-qualified by our partners. Browse live\n    deals or register to be kept informed of new opportunities.\n  "
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "action-wrap" }, [
        _c(
          "a",
          {
            staticClass: "cta-button",
            class: _vm.colorMode === "light" ? "medium-button" : "",
            on: { click: _vm.openLink },
          },
          [_vm._v("Engage with African businesses")]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }